import { render } from "./ORPaymentsReceived.vue?vue&type=template&id=c3e063a6&scoped=true"
import script from "./ORPaymentsReceived.vue?vue&type=script&lang=js"
export * from "./ORPaymentsReceived.vue?vue&type=script&lang=js"

import "./ORPaymentsReceived.vue?vue&type=style&index=0&id=c3e063a6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3e063a6"]])

export default __exports__